import { HttpService } from "@Engage.Data/services/http/HttpService";
import { localStorageService } from "@Engage.Data/services/storage/localStorage/LocalStorageService";
import { CookiesStorageService } from "@Engage.Data/services";
import { CookiesKeys, StorageKeys } from "@Engage.Data/constants/Constants";
import { UserDataModel } from "../model/UserDataModel";
import { DataEncryptor } from "@Core/utils/DataEncryptor";
import { UserStore } from "../model/UserStore";
import { Auth0Repository } from "../Auth0Repository";
import { logService } from "@Engage.Core";
export class UserService {
    static async syncUser(masterId, refreshData = false) {
        try {
            const refreshParam = refreshData ? '&refreshData=true' : '';
            let userData = await HttpService.get(`user/masterId?masterId=${masterId}${refreshParam}`);
            userData = DataEncryptor.decrypt(userData);
            if (!userData) {
                // API returned empty — treat as failure, fall through to default
                throw new Error("Empty user data response");
            }
            const userModel = new UserDataModel(userData);
            const encrypted = DataEncryptor.encrypt(userModel);
            localStorageService.set(StorageKeys.ConnextUserData, encrypted.toString(), {
                expandKey: false,
                isJson: false
            });
            CookiesStorageService.set(CookiesKeys.UserData, encrypted.toString(), { expires: 1 });
            UserStore.clearUser();
            UserStore.setUser(userModel);
            logService.log("[UserService] User synced", `UserState=${userModel.UserState}`);
            return userModel;
        }
        catch (err) {
            logService.warn("[UserService] Failed to fetch user data — setting default LoggedOut state", err);
            // Mirrors ConneXt v2 setUserDataOnError() → setDefaultUserData():
            // Create a default not-logged-in user so qualifiers get a clean state.
            return UserService.setDefaultUserData();
        }
    }
    /**
     * Mirrors ConneXt v2 AuthSystemModule.setDefaultUserData().
     * Creates a LoggedOut user model, clears storage, and clears the
     * expiration cookie so the next page load retries the API call.
     */
    static setDefaultUserData() {
        const defaultUser = new UserDataModel({ UserState: "LoggedIn" });
        // Clear any stale encrypted data
        localStorageService.delete(StorageKeys.ConnextUserData, { expandKey: false });
        CookiesStorageService.delete(CookiesKeys.UserData, { expandKey: false });
        // Clear expiration cookie so next page load retries the API
        new Auth0Repository().deleteUserDataExpiration();
        UserStore.clearUser();
        UserStore.setUser(defaultUser);
        return defaultUser;
    }
}
